export const faqItems = [
  { question: '6080影院需要注册才能观看吗？', answer: '不需要。6080影院所有影片均支持免注册免费在线观看，打开网站即可直接点播，无需登录、无需付费。' },
  { question: '播放过程中会出现卡顿缓冲吗？', answer: '6080影院采用多线CDN加速与智能码率适配技术，主流宽带环境下可实现零缓冲秒播。如遇卡顿，系统会自动切换至最优线路。' },
  { question: '支持哪些设备观看？', answer: '全面支持电脑、平板、手机等主流设备。电脑端直接访问网站，手机端可使用浏览器访问或收藏至桌面，随时随地观影无忧。' },
  { question: '影片更新频率如何？', answer: '片库每日更新，最新电影上线后24小时内即可在6080影院找到。经典电影、动作电影、喜剧电影等全品类持续扩充，保持片库新鲜度。' },
  { question: '可以下载影片离线观看吗？', answer: '6080影院定位为在线高清点播平台，当前仅支持在线播放。建议收藏站点随时回访，所有影片均长期保留不下架。' },
  { question: '遇到播放问题如何反馈？', answer: '您可以通过页面底部的"意见反馈"模块提交问题描述，我们的运维团队会在24小时内排查处理。常见问题也可先查阅本FAQ获取即时解答。' },
];

export const topicTags = [
  { name: '动作大片', count: '2,341部', hot: true },
  { name: '科幻巨制', count: '1,876部', hot: true },
  { name: '喜剧经典', count: '3,102部', hot: false },
  { name: '悬疑烧脑', count: '1,543部', hot: true },
  { name: '最新上线', count: '每日更新', hot: true },
  { name: '高分推荐', count: '8.5分+', hot: false },
  { name: '华语佳片', count: '4,720部', hot: false },
  { name: '好莱坞精选', count: '5,630部', hot: true },
  { name: '动漫剧场', count: '2,890部', hot: false },
  { name: '纪录片', count: '1,205部', hot: false },
  { name: '恐怖惊悚', count: '987部', hot: false },
];

export const mediaItems = [
  {
    title: '《暗影追踪》独家预告',
    desc: '国际知名导演最新力作，年度最受期待动作电影，高清预告全球同步首发。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20film%20scene%20with%20dramatic%20red%20and%20gold%20lighting%2C%20movie%20theater%20atmosphere%20with%20velvet%20curtains%2C%20film%20noir%20aesthetic%2C%20cinematographic%20composition%20with%20lens%20flare%20and%20warm%20glow%2C%20premium%20cinema%20visual%20style%2C%20deep%20shadows%20and%20rich%20contrast&width=800&height=450&seq=media-cinema-01&orientation=landscape',
  },
  {
    title: '《星际迷航：新纪元》幕后特辑',
    desc: '探秘科幻巨制的视觉特效制作过程，了解顶级电影工业背后的创意与匠心。',
    image: 'https://readdy.ai/api/search-image?query=Science%20fiction%20film%20visual%20effects%20studio%20scene%2C%20futuristic%20spaceship%20design%20with%20warm%20golden%20and%20deep%20red%20accents%2C%20cinematic%20lighting%20with%20dramatic%20shadows%2C%20movie%20production%20aesthetic%2C%20professional%20film%20industry%20atmosphere%2C%20rich%20dark%20background%20with%20glowing%20elements&width=800&height=450&seq=media-cinema-02&orientation=landscape',
  },
  {
    title: '喜剧电影年度混剪集锦',
    desc: '回顾今年最令人捧腹的经典喜剧瞬间，1080P高清画质，笑点密集全程高能。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20comedy%20film%20collage%20with%20bright%20warm%20lighting%2C%20golden%20theater%20stage%20atmosphere%2C%20classic%20movie%20poster%20aesthetic%20with%20red%20curtains%2C%20vintage%20cinema%20style%20with%20modern%20twist%2C%20rich%20contrast%20and%20elegant%20composition&width=800&height=450&seq=media-cinema-03&orientation=landscape',
  },
];

export const contactInfo = {
  title: '意见反馈与影片建议',
  intro: '您对6080影院有任何建议、影片推荐或播放问题，均可通过以下方式反馈。我们珍视每一位影迷的声音，共同打造更优质的观影体验。',
  email: 'feedback@6080cinema.com',
  responseTime: '通常24小时内回复',
  tips: ['推荐您钟爱的影片加入片库', '反馈播放技术问题', '提出功能改进建议'],
};

export const appInfo = {
  title: '6080影院 · 手机观影指南',
  intro: '无需下载安装任何APP，手机浏览器直接访问6080影院即可享受与电脑端一致的高清观影体验。将站点添加至手机桌面，一键直达电影大全片库。',
  steps: ['打开手机浏览器访问 6080 影院', '点击浏览器菜单选择"添加到主屏幕"', '桌面图标一键直达，随时随地免费看电影'],
  feature: '移动端自适应适配 · 流量优化播放 · 暗色护眼模式',
};

export const featureItems = [
  {
    icon: 'ri-movie-2-line',
    title: '海量片库',
    desc: '收录最新电影、经典电影、动作电影、喜剧电影等全品类资源，打造真正的电影大全，满足各类影迷口味。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速秒播',
    desc: '多线CDN智能调度与H.265高效编码结合，主流网络环境下实现点开即播、拖动零延迟的流畅观影体验。',
  },
  {
    icon: 'ri-hd-line',
    title: '高清画质',
    desc: '全线影片支持1080P蓝光级画质，部分热门内容提供4K超清选项，配合自适应码率技术不缓冲播放。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端兼容',
    desc: '电脑、平板、手机全设备完美适配。无需安装客户端，浏览器打开即用，真正随时随地免费看电影。',
  },
  {
    icon: 'ri-calendar-check-line',
    title: '每日更新',
    desc: '片库每日持续扩充，最新电影上线后极速收录。经典电影长期保留不下架，打造永不过时的影视大全平台。',
  },
];

export const carouselItems = [
  {
    title: '暑期档必看 · 十大动作电影精选',
    desc: '从经典港片到好莱坞巨制，精选十部肾上腺素全程拉满的动作大片，这个夏天不容错过。',
    tag: '编辑精选',
    image: 'https://readdy.ai/api/search-image?query=Action%20movie%20cinematic%20poster%20style%20with%20explosive%20dynamic%20composition%2C%20deep%20red%20and%20gold%20lighting%2C%20hero%20silhouette%20against%20dramatic%20skyline%2C%20film%20poster%20aesthetic%20with%20bold%20contrast%2C%20dark%20theater%20atmosphere%2C%20premium%20cinema%20visual&width=600&height=400&seq=carousel-cinema-01&orientation=landscape',
  },
  {
    title: '华语经典重温 · 豆瓣8.5分+ 佳片合集',
    desc: '那些年我们一起追过的华语好片，从文艺到商业，每部都是时光淬炼后的光影宝藏。',
    tag: '高分推荐',
    image: 'https://readdy.ai/api/search-image?query=Classic%20Chinese%20cinema%20nostalgic%20film%20scene%20with%20warm%20sepia%20tones%2C%20vintage%20movie%20poster%20aesthetic%2C%20golden%20hour%20lighting%20on%20film%20reel%2C%20artistic%20composition%20with%20red%20accents%2C%20elegant%20dark%20background%2C%20premium%20cinematography%20style&width=600&height=400&seq=carousel-cinema-02&orientation=landscape',
  },
  {
    title: '科幻迷盛宴 · 年度视觉特效巅峰之作',
    desc: '从太空史诗到赛博朋克，汇聚近年最炸裂的科幻电影，用想象力突破银幕边界。',
    tag: '视觉盛宴',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20visual%20with%20neon%20glow%20and%20cosmic%20background%2C%20cinematic%20space%20scene%20with%20dramatic%20red%20and%20gold%20lighting%2C%20film%20poster%20aesthetic%2C%20deep%20dark%20space%20with%20stunning%20visual%20effects%2C%20premium%20cinema%20quality&width=600&height=400&seq=carousel-cinema-03&orientation=landscape',
  },
  {
    title: '笑到停不下来 · 喜剧电影精选片单',
    desc: '工作累了？生活烦了？打开这份喜剧片单，从无厘头到黑色幽默，总有一部让你开怀大笑。',
    tag: '欢乐时光',
    image: 'https://readdy.ai/api/search-image?query=Comedy%20film%20cinematic%20scene%20with%20bright%20warm%20lighting%2C%20theater%20stage%20with%20red%20velvet%20curtains%2C%20playful%20movie%20poster%20composition%2C%20golden%20spotlight%20effect%2C%20dark%20elegant%20background%2C%20classic%20cinema%20aesthetic%20with%20joyful%20atmosphere&width=600&height=400&seq=carousel-cinema-04&orientation=landscape',
  },
  {
    title: '深夜剧场 · 悬疑惊悚口碑榜',
    desc: '一个人关灯戴上耳机，挑战心理极限。精选近年最烧脑的悬疑电影与最吓人的惊悚佳作。',
    tag: '胆小慎入',
    image: 'https://readdy.ai/api/search-image?query=Suspenseful%20thriller%20film%20noir%20aesthetic%20with%20dramatic%20shadow%20play%2C%20dark%20cinematic%20composition%20with%20red%20accent%20lighting%2C%20mysterious%20atmosphere%2C%20film%20poster%20style%20with%20deep%20contrast%2C%20elegant%20dark%20theater%20visual%2C%20premium%20cinema%20quality&width=600&height=400&seq=carousel-cinema-05&orientation=landscape',
  },
];

export const commentItems = [
  {
    name: '影迷小王',
    title: '终于找到一个不用注册就能看的电影网站',
    text: '之前用了好几个影视大全APP都要注册登录，6080影院直接打开就能看，片库还特别全，最新的动作电影和经典老片都有，画质也好，真是良心平台。',
    rating: 5,
    time: '2小时前',
  },
  {
    name: '老张看电影',
    title: '片库更新速度是真的快',
    text: '昨天上映的最新电影，今天就在6080影院找到了，而且是高清画质不缓冲播放。喜剧电影和动作电影分类也很清晰，找片很方便。',
    rating: 5,
    time: '5小时前',
  },
  {
    name: '周末影迷会',
    title: '手机观影体验出乎意料的好',
    text: '本来担心手机看会卡，结果流畅得很。晚上躺床上刷了几部经典电影，画质清晰音效也不错。已经在手机桌面建了快捷方式。',
    rating: 4,
    time: '1天前',
  },
  {
    name: '电影发烧友阿杰',
    title: '电影大全名副其实，分类很专业',
    text: '作为一个看了上千部电影的影迷，6080影院的片库深度让我惊讶。从主流大作到冷门经典都有覆盖，推荐系统也开始有模有样了。',
    rating: 5,
    time: '2天前',
  },
];

export const updateItems = [
  { date: '2026-07-31', title: '《雷霆追击2》高清上线', desc: '年度动作大片续作，全新剧情升级，1080P蓝光品质首发。' },
  { date: '2026-07-30', title: '喜剧电影专区扩容', desc: '新增200+部经典喜剧电影，涵盖国内外各年代代表作。' },
  { date: '2026-07-29', title: '播放线路全面升级', desc: '新增三条CDN加速线路，全国用户均可享受不缓冲观影体验。' },
  { date: '2026-07-28', title: '《星际迷航：新纪元》独家上线', desc: '科幻巨制电影大全首发，4K超清画质带来极致视觉享受。' },
  { date: '2026-07-27', title: '经典电影修复计划启动', desc: '首批50部经典电影完成数字修复，画质全面升级至1080P。' },
  { date: '2026-07-26', title: '手机端观影体验优化', desc: '移动端界面重构完成，加载速度提升40%，流量消耗降低30%。' },
  { date: '2026-07-25', title: '用户推荐系统上线', desc: '基于观影偏好的智能推荐，帮你发现更多符合口味的好电影。' },
];

export const cardItems = [
  {
    title: '硬核动作 · 肾上腺素飙升',
    desc: '精选20部高分动作电影合集',
    category: '动作大片',
    image: 'https://readdy.ai/api/search-image?query=Intense%20action%20movie%20cinematic%20scene%20with%20dramatic%20red%20and%20gold%20lighting%2C%20explosive%20visual%20effects%2C%20film%20poster%20aesthetic%2C%20dark%20background%20with%20warm%20accents%2C%20premium%20cinema%20quality%2C%20dynamic%20composition&width=600&height=360&seq=cards-cinema-01&orientation=landscape',
  },
  {
    title: '爆笑合集 · 快乐不设限',
    desc: '从无厘头到黑色幽默一网打尽',
    category: '喜剧经典',
    image: 'https://readdy.ai/api/search-image?query=Comedy%20movie%20collage%20with%20warm%20golden%20lighting%2C%20theater%20curtains%20in%20deep%20red%2C%20classic%20film%20comedy%20aesthetic%2C%20dark%20background%20with%20playful%20elements%2C%20premium%20cinema%20visual%20style%2C%20elegant%20composition&width=600&height=360&seq=cards-cinema-02&orientation=landscape',
  },
  {
    title: '科幻前沿 · 想象无边界',
    desc: '年度科幻大片的视觉盛宴指南',
    category: '科幻巨制',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20visual%20with%20cosmic%20nebula%20and%20neon%20glow%2C%20cinematic%20space%20scene%2C%20dark%20background%20with%20red%20and%20gold%20highlights%2C%20film%20poster%20aesthetic%2C%20premium%20cinema%20quality%2C%20dramatic%20composition&width=600&height=360&seq=cards-cinema-03&orientation=landscape',
  },
  {
    title: '华语之光 · 国产佳片巡礼',
    desc: '豆瓣高分华语电影年度精选',
    category: '华语佳片',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20cinema%20artistic%20film%20scene%20with%20warm%20nostalgic%20tones%2C%20traditional%20elements%20blended%20with%20modern%20cinematography%2C%20golden%20lighting%20on%20film%20reel%2C%20dark%20background%20with%20red%20accents%2C%20premium%20quality&width=600&height=360&seq=cards-cinema-04&orientation=landscape',
  },
  {
    title: '悬疑烧脑 · 智商全程在线',
    desc: '反转不断的悬疑电影口碑榜',
    category: '悬疑惊悚',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20thriller%20film%20noir%20scene%20with%20deep%20shadows%20and%20dramatic%20red%20lighting%2C%20suspenseful%20cinematic%20composition%2C%20film%20poster%20aesthetic%2C%20dark%20elegant%20background%2C%20premium%20cinema%20quality%2C%20artistic%20visual&width=600&height=360&seq=cards-cinema-05&orientation=landscape',
  },
  {
    title: '温情治愈 · 暖到心坎里',
    desc: '那些让人笑着流泪的治愈电影',
    category: '温情剧情',
    image: 'https://readdy.ai/api/search-image?query=Warm%20emotional%20film%20scene%20with%20soft%20golden%20sunlight%2C%20cinematic%20intimate%20moment%2C%20tender%20atmosphere%20with%20red%20and%20gold%20accents%2C%20film%20poster%20aesthetic%2C%20dark%20background%2C%20premium%20cinema%20quality&width=600&height=360&seq=cards-cinema-06&orientation=landscape',
  },
  {
    title: '动漫世界 · 二次元狂欢',
    desc: '国内外热门动漫电影一站式观看',
    category: '动漫剧场',
    image: 'https://readdy.ai/api/search-image?query=Animated%20film%20cinematic%20scene%20with%20vibrant%20colors%20and%20dramatic%20lighting%2C%20anime%20movie%20poster%20aesthetic%2C%20dark%20background%20with%20red%20and%20gold%20highlights%2C%20premium%20cinema%20visual%2C%20dynamic%20composition&width=600&height=360&seq=cards-cinema-07&orientation=landscape',
  },
];

export const indexItems = [
  { title: '最新电影', desc: '每日更新的最新上线影片，紧跟全球电影动态', icon: 'ri-fire-line', count: '386部' },
  { title: '动作电影', desc: '高燃打斗、极速追逐、硬汉对决', icon: 'ri-flashlight-line', count: '2,341部' },
  { title: '喜剧电影', desc: '轻松一笑，从经典喜剧到最新笑料', icon: 'ri-emotion-happy-line', count: '3,102部' },
  { title: '科幻电影', desc: '探索宇宙、人工智能与未来世界', icon: 'ri-rocket-line', count: '1,876部' },
  { title: '悬疑电影', desc: '烧脑反转、心理博弈、真相追寻', icon: 'ri-search-eye-line', count: '1,543部' },
  { title: '经典电影', desc: '时光淬炼的影史佳作，永不过时', icon: 'ri-vip-crown-line', count: '5,890部' },
  { title: '恐怖惊悚', desc: '肾上腺素与心跳的双重考验', icon: 'ri-ghost-line', count: '987部' },
  { title: '动漫电影', desc: '从宫崎骏到新海诚，动画之美', icon: 'ri-palette-line', count: '2,890部' },
  { title: '纪录片', desc: '真实世界的精彩故事与深度观察', icon: 'ri-earth-line', count: '1,205部' },
];

export const aboutInfo = {
  intro: '6080影院是国内领先的免费在线电影大全平台，致力于为影迷提供最新电影、经典电影、动作电影、喜剧电影等全品类高清观影服务。自上线以来，我们始终坚持"不缓冲播放、全免费观看"的核心承诺，持续扩充片库、优化播放体验。',
  mission: '让每个人都能轻松享受电影的乐趣',
  stats: [
    { value: '20,000+', label: '片库总量' },
    { value: '8,000万+', label: '累计播放' },
    { value: '99.9%', label: '在线率' },
    { value: '7×24', label: '运维保障' },
  ],
};

export const rankingItems = [
  { rank: 1, title: '雷霆追击2', category: '动作电影', score: '9.2', hot: '本周最热' },
  { rank: 2, title: '星际迷航：新纪元', category: '科幻巨制', score: '8.9', hot: '新上榜' },
  { rank: 3, title: '笑傲江湖2026', category: '喜剧电影', score: '8.7', hot: '上升5位' },
  { rank: 4, title: '暗影追踪', category: '动作电影', score: '8.6', hot: '持续在榜' },
  { rank: 5, title: '深海迷踪', category: '悬疑惊悚', score: '8.5', hot: '上升2位' },
  { rank: 6, title: '回到1999', category: '经典电影', score: '8.4', hot: '经典回顾' },
  { rank: 7, title: '喵星人总动员', category: '动漫电影', score: '8.3', hot: '新上榜' },
];